import { gql } from '@apollo/client';

import { EBookingStatus } from '../../types';
import { IBooking } from './types';

export interface IBookingsResponse {
  getBookings: {
    data: Array<IBooking>;
  };
}

export interface IBookingsRequest {
  hostIds: Array<number>;
  status: EBookingStatus;
  from: string;
  to: string;
}
export const BOOKINGS = gql`
  query getBookingsV2(
    $hostIds: [Int!]
    $status: BookingStatus
    $from: DateTime
    $to: DateTime
  ) {
    getBookings(hostIds: $hostIds, status: $status, from: $from, to: $to) {
      data {
        id
        from
        to
        byClient
        client {
          uuid
          nickname
        }
      }
    }
  }
`;

export interface IHostResponse {
  hostOverview: {
    alias: string;
  };
}
export const HOST = gql`
  query hostData($id: Int!) {
    hostOverview(id: $id) {
      alias
    }
  }
`;
